<template>
  <div class="animated fadeIn">
    자주 묻는 질문
    <b-card style="height:500px" class="bs-callout bs-callout-primary panelScrollBar">
      <div>
        <b-row>
          <b-col sm='6'>
            <div v-html="content"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data(){
    return {
      content : null,
    }
  },
  created: function() {

  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    this.$http.get('/api/select/selectManagerBoardData?access_token='+token+'&contetn_serial='+15)
      .then((result) => {
        this.content = result.data.content;
        // window.btoa(this.content);
        // console.log(window.atob(result.data.content));
        // var boardContentData = JSON.parse(result.data);
        // console.log(boardContentData);
        // this.content =  window.atob(result.data.content);

        // var param = JSON.parse(result.data);
        // console.log(window.atob(result.data.content));
        console.log(result.data.content.replace(/ /gi, '+'));
        // this.content =  window.atob(result.data.content.replace(/ /gi, '+'));
        // this.content =  result.data.content.replace(/ /gi, '+');
      })
  },
  methods: {

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/management/board/QA.vue